import libphonenumber from 'google-libphonenumber';

export const getRegionByPhoneNumber = (
  phoneNumber: string | number,
): string => {
  const phoneUtil = libphonenumber.PhoneNumberUtil.getInstance();
  const formattedPhoneNumber = `+${phoneNumber}`;

  try {
    const parsedPhoneNumber =
      phoneUtil.parseAndKeepRawInput(formattedPhoneNumber);
    const regionCode = phoneUtil.getRegionCodeForNumber(parsedPhoneNumber);

    if (regionCode) {
      const displayNames = new Intl.DisplayNames(['en'], { type: 'region' });
      return displayNames.of(regionCode) || 'Unknown region';
    }
  } catch {
    return 'Unknown region';
  }

  return 'Unknown region';
};

export const getCountryCodeByPhoneNumber = (
  phoneNumber: string | number,
): string => {
  const phoneUtil = libphonenumber.PhoneNumberUtil.getInstance();
  const formattedPhoneNumber = `+${phoneNumber}`;

  try {
    const parsedPhoneNumber =
      phoneUtil.parseAndKeepRawInput(formattedPhoneNumber);
    const regionCode = phoneUtil.getRegionCodeForNumber(parsedPhoneNumber);

    if (regionCode) {
      return regionCode.toLowerCase();
    }
  } catch {
    return 'zz';
  }

  return 'zz';
};
